import React, { useContext } from "react";
import AdminHeader from "../../components/AdminHeader";
import HomePageFooter from "../../components/HomePageFooter";
import { AdminNavigator } from "../../components/AdminNavigator";
import AdminManageProduct from "../../components/AdminManageProductBlock";
import AdminManageSeller from "../../components/AdminManageSellerBlock";
import AdminManageUser from "../../components/AdminManageUserBlock";
import AdminCategoryManager from "../../components/AdminCategoryManager"; // Correct import
import styles from "./adminpage.module.css";
import { NavigationContext } from "../../context/Admin_context";

export default function AdminPage() {
  const { open } = useContext(NavigationContext);

  return (
    
    <div className={`container-fluid h-custom ${styles.page}`}>
      <div className="row Header">
        <AdminHeader />
      </div>
      <div className="row Body">
        <div className="col-3 px-0" style={{width: "18%"}}>
          <AdminNavigator />
        </div>
        <div className={`col-9 ${styles.AdminBlock}`} style={{width: "82%"}}>
          {open.isManageUsers && <AdminManageUser />}
          {open.isManageSeller && <AdminManageSeller />}
          {open.isManageProduct && <AdminManageProduct />}
          {open.isManageCategories && <AdminCategoryManager />}
        </div>
      </div>
      <div className="row footer">
        <HomePageFooter />
      </div>
    </div>
  );
}
